// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2LuJ7","content":"RecentSearches_content__15MpX"};